'use client';

import React, { type ReactElement, type ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { shouldHideMobileBottomNav } from '@/features/shop/components/witro-mobile-nav.component';
import { selectIsTenant, useDomainStore } from '@/store/use-domain.store';
import classNames from 'classnames';

export interface FixedBottomProps {
  children: ReactNode;
  className?: string;
}

export default function FixedBottom({
  children,
  className = '',
}: FixedBottomProps): ReactElement {
  const isTenant = useDomainStore(selectIsTenant);
  const pathname = usePathname();
  const sitAboveBottomNav =
    !isTenant && !shouldHideMobileBottomNav(pathname);

  return (
    <div
      className={classNames(
        // Above page content (buttons use z-50) and below mobile nav (z-[60]).
        'fixed-bottom-component fixed inset-x-0 z-[55] flex h-[92px] w-full isolate items-center border-t border-silver-300 bg-white px-4 py-6 lg:bottom-0 lg:bg-transparent',
        sitAboveBottomNav ? 'bottom-16' : 'bottom-0',
        className
      )}
    >
      {children}
    </div>
  );
}
